define(['jquery', 'app/global', 'jquery.pkoRadio', 'jquery.pkoCheckbox', 'jquery.pkoSelect', 'jquery.pkoEscape'], function ($, global) {

  var $form = $('form'),
    $select,
    $radio,
    $checkbox;

  if ($form.length) {

    $select = $form.find('select');
    if ($select.length) {
      $select.pkoSelect();//2DO jqueru ui
    }

    $('.first_name, .last_name').escape(/^[A-ZĄŻŹĆŃŁÓĘŚa-zążźćńłóęś '-]*$/);

    $radio = $form.find('input[type="radio"]');
    if ($radio.length) {
      $radio.pkoRadio();
    }

    $checkbox = $form.find('input[type="checkbox"]');
    if ($checkbox.length) {
      $checkbox.pkoCheckbox();
    }

    $form.each(function () {

      var $this = $(this),
        $formAgreement,
        $tooltip,
        $agreementCopy;

      $formAgreement = $this.find('.form-show-agreement');

      $tooltip = $this.find('.tooltip-form');
      if ($formAgreement.length && $tooltip.length) {

        $tooltip.on('click', function (e) {
          e.stopImmediatePropagation();
        });

        $formAgreement.on('click', function (e) {
          var $this = $(this),
            href = $this.attr('href'),
            $currentTooltip,
            $otherTooltip;
          if (href) {
            $currentTooltip = $(href);
            $otherTooltip = $tooltip.filter(':visible');
            if ($otherTooltip.length) {
              $otherTooltip.hide();
              global.cache.$html.off('click.tooltip');
            }
            if ($currentTooltip.length) {
              $currentTooltip.show().css('bottom', $currentTooltip.parent().height() + 5);
              var offset = $currentTooltip.offset();
              if (offset.left < 0) {
                $currentTooltip.css('left', '-=' + Math.ceil(offset.left));
              }
              global.cache.$html.one('click.tooltip', function () {
                $currentTooltip.hide();
              });
            }
          }
          e.stopImmediatePropagation();
          e.preventDefault();
        });

      }

    });


  }

});



// WEBPACK FOOTER //
// ./_front/_inteligo/js/app/form-common.js